export const pptContentAllJSON = [
    {
        page_type: '封面',
        data: {
            封面标题: '这里填PPT主标题',
            封面副标题: '这里填PPT副标题',
            汇报日期: '2024-09-24',
        },
    },
    {
        page_type: '目录',
        component_point: 1,
        data: {
            '目录标题:1': '这里填第1章标题',
        },
    },
    {
        page_type: '目录',
        component_point: 2,
        data: {
            '目录标题:1': '这里填第1章标题',
            '目录标题:2': '这里填第2章标题',
        },
    },
    {
        page_type: '目录',
        component_point: 3,
        data: {
            '目录标题:1': '这里填第1章标题',
            '目录标题:2': '这里填第2章标题',
            '目录标题:3': '这里填第3章标题',
        },
    },
    {
        page_type: '目录',
        component_point: 4,
        data: {
            '目录标题:1': '这里填第1章标题',
            '目录标题:2': '这里填第2章标题',
            '目录标题:3': '这里填第3章标题',
            '目录标题:4': '这里填第4章标题',
        },
    },
    {
        page_type: '目录',
        component_point: 5,
        data: {
            '目录标题:1': '这里填第1章标题',
            '目录标题:2': '这里填第2章标题',
            '目录标题:3': '这里填第3章标题',
            '目录标题:4': '这里填第4章标题',
            '目录标题:5': '这里填第5章标题',
        },
    },
    {
        page_type: '目录',
        component_point: 6,
        data: {
            '目录标题:1': '这里填第1章标题',
            '目录标题:2': '这里填第2章标题',
            '目录标题:3': '这里填第3章标题',
            '目录标题:4': '这里填第4章标题',
            '目录标题:5': '这里填第5章标题',
            '目录标题:6': '这里填第6章标题',
        },
    },
    {
        page_type: '目录',
        component_point: 7,
        data: {
            '目录标题:1': '这里填第1章标题',
            '目录标题:2': '这里填第2章标题',
            '目录标题:3': '这里填第3章标题',
            '目录标题:4': '这里填第4章标题',
            '目录标题:5': '这里填第5章标题',
            '目录标题:6': '这里填第6章标题',
            '目录标题:7': '这里填第7章标题',
        },
    },
    {
        page_type: '目录',
        component_point: 8,
        data: {
            '目录标题:1': '这里填第1章标题',
            '目录标题:2': '这里填第2章标题',
            '目录标题:3': '这里填第3章标题',
            '目录标题:4': '这里填第4章标题',
            '目录标题:5': '这里填第5章标题',
            '目录标题:6': '这里填第6章标题',
            '目录标题:7': '这里填第7章标题',
            '目录标题:8': '这里填第8章标题',
        },
    },
    {
        page_type: '目录',
        component_point: 9,
        data: {
            '目录标题:1': '这里填第1章标题',
            '目录标题:2': '这里填第2章标题',
            '目录标题:3': '这里填第3章标题',
            '目录标题:4': '这里填第4章标题',
            '目录标题:5': '这里填第5章标题',
            '目录标题:6': '这里填第6章标题',
            '目录标题:7': '这里填第7章标题',
            '目录标题:8': '这里填第8章标题',
            '目录标题:9': '这里填第9章标题',
        },
    },
    {
        page_type: '目录',
        component_point: 10,
        data: {
            '目录标题:1': '这里填第1章标题',
            '目录标题:2': '这里填第2章标题',
            '目录标题:3': '这里填第3章标题',
            '目录标题:4': '这里填第4章标题',
            '目录标题:5': '这里填第5章标题',
            '目录标题:6': '这里填第6章标题',
            '目录标题:7': '这里填第7章标题',
            '目录标题:8': '这里填第8章标题',
            '目录标题:9': '这里填第9章标题',
            '目录标题:10': '这里填第10章标题',
        },
    },
    {
        page_type: '章节',
        data: {
            章节标题: '这里填第1章标题',
            章节序号: 1,
        },
    },
    {
        page_type: '章节',
        data: {
            章节标题: '这里填第2章标题',
            章节序号: 2,
        },
    },
    {
        page_type: '章节',
        data: {
            章节标题: '这里填第3章标题',
            章节序号: 3,
        },
    },
    {
        page_type: '章节',
        data: {
            章节标题: '这里填第4章标题',
            章节序号: 4,
        },
    },
    {
        page_type: '章节',
        data: {
            章节标题: '这里填第5章标题',
            章节序号: 5,
        },
    },
    {
        page_type: '章节',
        data: {
            章节标题: '这里填第6章标题',
            章节序号: 6,
        },
    },
    {
        page_type: '章节',
        data: {
            章节标题: '这里填第7章标题',
            章节序号: 7,
        },
    },
    {
        page_type: '章节',
        data: {
            章节标题: '这里填第8章标题',
            章节序号: 8,
        },
    },
    {
        page_type: '章节',
        data: {
            章节标题: '这里填第9章标题',
            章节序号: 9,
        },
    },
    {
        page_type: '章节',
        data: {
            章节标题: '这里填第10章标题',
            章节序号: 10,
        },
    },
    {
        page_type: '内容',
        data: {
            章节标题: '这里填第1章标题',
            章节序号: 1,
            内容标题: '这里填内容标题',
            内容总结: '这里是段落总结，可以不填, 但也可以填写一些关于当前页面的总结。',
            '列表标题:1': '列表标题1',
            '列表内容:1':
                '列表内容1, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
        },
        component_point: 1,
    },
    {
        page_type: '内容',
        data: {
            章节标题: '这里填第1章标题',
            章节序号: 1,
            内容标题: '这里填内容标题',
            内容总结: '这里是段落总结，可以不填, 但也可以填写一些关于当前页面的总结。',
            '列表标题:1': '列表标题1',
            '列表内容:1':
                '列表内容1, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:2': '列表标题2',
            '列表内容:2':
                '列表内容2, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
        },
        component_point: 2,
    },
    {
        page_type: '内容',
        data: {
            章节标题: '这里填第1章标题',
            章节序号: 1,
            内容标题: '这里填内容标题',
            内容总结: '这里是段落总结，可以不填, 但也可以填写一些关于当前页面的总结。',
            '列表标题:1': '列表标题1',
            '列表内容:1':
                '列表内容1, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:2': '列表标题2',
            '列表内容:2':
                '列表内容2, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:3': '列表标题3',
            '列表内容:3':
                '列表内容3, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
        },
        component_point: 3,
    },
    {
        page_type: '内容',
        data: {
            章节标题: '这里填第1章标题',
            章节序号: 1,
            内容标题: '这里填内容标题',
            内容总结: '这里是段落总结，可以不填, 但也可以填写一些关于当前页面的总结。',
            '列表标题:1': '列表标题1',
            '列表内容:1':
                '列表内容1, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:2': '列表标题2',
            '列表内容:2':
                '列表内容2, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:3': '列表标题3',
            '列表内容:3':
                '列表内容3, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:4': '列表标题4',
            '列表内容:4':
                '列表内容4, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
        },
        component_point: 4,
    },
    {
        page_type: '内容',
        data: {
            章节标题: '这里填第1章标题',
            章节序号: 1,
            内容标题: '这里填内容标题',
            内容总结: '这里是段落总结，可以不填, 但也可以填写一些关于当前页面的总结。',
            '列表标题:1': '列表标题1',
            '列表内容:1':
                '列表内容1, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:2': '列表标题2',
            '列表内容:2':
                '列表内容2, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:3': '列表标题3',
            '列表内容:3':
                '列表内容3, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:4': '列表标题4',
            '列表内容:4':
                '列表内容4, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:5': '列表标题5',
            '列表内容:5':
                '列表内容5, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
        },
        component_point: 5,
    },
    {
        page_type: '内容',
        data: {
            章节标题: '这里填第1章标题',
            章节序号: 1,
            内容标题: '这里填内容标题',
            内容总结: '这里是段落总结，可以不填, 但也可以填写一些关于当前页面的总结。',
            '列表标题:1': '列表标题1',
            '列表内容:1':
                '列表内容1, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:2': '列表标题2',
            '列表内容:2':
                '列表内容2, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:3': '列表标题3',
            '列表内容:3':
                '列表内容3, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:4': '列表标题4',
            '列表内容:4':
                '列表内容4, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:5': '列表标题5',
            '列表内容:5':
                '列表内容5, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:6': '列表标题6',
            '列表内容:6':
                '列表内容6, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
        },
        component_point: 6,
    },
    {
        page_type: '内容',
        data: {
            章节标题: '这里填第1章标题',
            章节序号: 1,
            内容标题: '这里填内容标题',
            内容总结: '这里是段落总结，可以不填, 但也可以填写一些关于当前页面的总结。',
            '列表标题:1': '列表标题1',
            '列表内容:1':
                '列表内容1, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:2': '列表标题2',
            '列表内容:2':
                '列表内容2, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:3': '列表标题3',
            '列表内容:3':
                '列表内容3, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:4': '列表标题4',
            '列表内容:4':
                '列表内容4, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:5': '列表标题5',
            '列表内容:5':
                '列表内容5, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:6': '列表标题6',
            '列表内容:6':
                '列表内容6, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:7': '列表标题7',
            '列表内容:7':
                '列表内容7, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
        },
        component_point: 7,
    },
    {
        page_type: '内容',
        data: {
            章节标题: '这里填第1章标题',
            章节序号: 1,
            内容标题: '这里填内容标题',
            内容总结: '这里是段落总结，可以不填, 但也可以填写一些关于当前页面的总结。',
            '列表标题:1': '列表标题1',
            '列表内容:1':
                '列表内容1, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:2': '列表标题2',
            '列表内容:2':
                '列表内容2, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:3': '列表标题3',
            '列表内容:3':
                '列表内容3, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:4': '列表标题4',
            '列表内容:4':
                '列表内容4, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:5': '列表标题5',
            '列表内容:5':
                '列表内容5, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:6': '列表标题6',
            '列表内容:6':
                '列表内容6, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:7': '列表标题7',
            '列表内容:7':
                '列表内容7, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:8': '列表标题8',
            '列表内容:8':
                '列表内容8, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
        },
        component_point: 8,
    },
    {
        page_type: '内容',
        data: {
            章节标题: '这里填第1章标题',
            章节序号: 1,
            内容标题: '这里填内容标题',
            内容总结: '这里是段落总结，可以不填, 但也可以填写一些关于当前页面的总结。',
            '列表标题:1': '列表标题1',
            '列表内容:1':
                '列表内容1, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:2': '列表标题2',
            '列表内容:2':
                '列表内容2, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:3': '列表标题3',
            '列表内容:3':
                '列表内容3, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:4': '列表标题4',
            '列表内容:4':
                '列表内容4, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:5': '列表标题5',
            '列表内容:5':
                '列表内容5, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:6': '列表标题6',
            '列表内容:6':
                '列表内容6, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:7': '列表标题7',
            '列表内容:7':
                '列表内容7, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:8': '列表标题8',
            '列表内容:8':
                '列表内容8, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:9': '列表标题9',
            '列表内容:9':
                '列表内容9, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
        },
        component_point: 9,
    },
    {
        page_type: '内容',
        data: {
            章节标题: '这里填第1章标题',
            章节序号: 1,
            内容标题: '这里填内容标题',
            内容总结: '这里是段落总结，可以不填, 但也可以填写一些关于当前页面的总结。',
            '列表标题:1': '列表标题1',
            '列表内容:1':
                '列表内容1, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:2': '列表标题2',
            '列表内容:2':
                '列表内容2, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:3': '列表标题3',
            '列表内容:3':
                '列表内容3, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:4': '列表标题4',
            '列表内容:4':
                '列表内容4, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:5': '列表标题5',
            '列表内容:5':
                '列表内容5, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:6': '列表标题6',
            '列表内容:6':
                '列表内容6, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:7': '列表标题7',
            '列表内容:7':
                '列表内容7, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:8': '列表标题8',
            '列表内容:8':
                '列表内容8, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:9': '列表标题9',
            '列表内容:9':
                '列表内容9, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
            '列表标题:10': '列表标题10',
            '列表内容:10':
                '列表内容10, 厦门位于中国东南沿海，拥有得天独厚的海洋资源和温暖的亚热带气候，是我国著名的旅游城市。',
        },
        component_point: 9,
    },
    {
        page_type: '致谢',
        data: {
            封面标题: '这里填PPT主标题',
            封面副标题: '这里填PPT副标题',
            汇报日期: '2024-09-24',
        },
    },
];
